export const formatLink = (url: string): string => {
  if (!url) return "";
  // check beforehand
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  // if not, add https
  return `https://${url}`;
};

export const encodeLastUriComponent = (url: string): string => {
  if (!url) return "";
  const lastSlashIndex = url.lastIndexOf("/");
  if (lastSlashIndex === -1) return encodeURIComponent(url);
  return (
    url.substring(0, lastSlashIndex + 1) +
    encodeURIComponent(url.substring(lastSlashIndex + 1))
  );
};
